/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Checkbox, Label } from 'semantic-ui-react';
import cx from 'classnames';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';
import filterIcon from '../../images/components/contnets_header/filter icon.png';
import deleteIcon from '../../images/components/contnets_header/delete-icon-red.svg';

class SettingContentsHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      checkValue: [],
      //radioValue: 'active',
      errSearch: false,
      isFocus: false,
      isDisableStatus: props.isDisableStatus || false,
      isDisableDelete: props.isDisableDelete || false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.assignProject = this.assignProject.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.addNewProject = this.addNewProject.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { isDisableStatus, isDisableDelete, filter } = this.props;
    const { checkValue } = this.state;
    const filterLength = filter.length;

    if (prevProps.isDisableStatus !== isDisableStatus) {
      this.setState({
        isDisableStatus,
      });
    }

    if (prevProps.isDisableDelete !== isDisableDelete) {
      this.setState({
        isDisableDelete,
      });
    }

    if (filter && prevProps.filter !== filter) {
      if (filterLength !== checkValue.length) {
        this.setState({
          checkValue: filter,
        });
      }
    }

  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleSearch(event) {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      setTimeout(() => {
        this.setState({
          isFocus: false,
        });
      }, 1500);
      this.props.onChangeSearch(event.target.value);
    }
  }

  handleClickOutside(event) {
    if (this.toggleBtn && !this.toggleBtn.contains(event.target)) {
      this.setState({
        visible: false,
      });
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  onSubmit() {
    const { checkValue } = this.state;

    this.setState({
      visible: false,
    });

    this.props.onSubmit(
      { filter: checkValue, }
    );
  }

  deleteBtn = () => {
    const { translate } = this.props;
    const { isDisableDelete } = this.state;

    if (isDisableDelete) {
      return (
        <a
          className="delete_button util_button"
          style={{
            pointerEvents: 'none',
            cursor: 'default',
            opacity: '.45',
          }}
        >
          <span>
            <img src={deleteIcon} alt="" style={{ width: '12px' }} />
          </span>
          {translate('modal.button.delete')}
        </a>
      );
    }
    return (
      <a
        className="delete_button util_button"
        style={{ cursor: 'pointer' }}
        onClick={this.deleteProject}
        onKeyUp={this.deleteProject}
      >
        <span>
          <img src={deleteIcon} alt="" style={{ width: '12px' }} />
        </span>
        {translate('modal.button.delete')}
      </a>
    );
  };

  changeStatusBtn = () => {
    const { translate } = this.props;
    const { isDisableStatus } = this.state;
    if (isDisableStatus) {
      return (
        <a
          className="gray_button util_button"
          style={{
            pointerEvents: 'none',
            cursor: 'default',
            opacity: '.45',
          }}
        >
          {translate('contents_header.menu.change_status')}
        </a>
      );
    }
    return (
      <a
        className="gray_button util_button"
        style={{ cursor: 'pointer' }}
        onClick={this.changeStatus}
        onKeyUp={this.changeStatus}
      >
        {translate('contents_header.menu.change_status')}
      </a>
    );
  };

  guideText = () => {
    const { translate } = this.props;
    if (this.props.location.indexOf('project') !== -1) {
      return translate('settings.list.project_guide_text');
    } if (this.props.location.indexOf('user') !== -1) {
      if (this.props.state.user.isSuperAdmin) {
        return translate('settings.list.company_guide_text');
      }
      return translate('settings.list.user_guide_text');
    }
  };

  toggleMenu() {
    const { visible } = this.state;
    this.setState({
      visible: !visible,
    });
  }

  assignProject() {
    this.props.assignProject();
  }

  closeMenu() {
    this.setState({
      visible: false,
    });
  }

  clearSearch() {
    this.search.value = '';
    this.props.clearSearch();
  }

  changeStatus() {
    this.props.changeStatus();
  }

  deleteProject() {
    this.props.deleteProject();
  }

  addNewProject() {
    if (this.props.location.indexOf('project') !== -1) {
      this.props.addNewProject();
    } else {
      this.props.addNewUser();
    }
  }

  render() {
    const { checkValue, errSearch, isFocus } = this.state;
    const { translate } = this.props;

    return (
      <div className="contents_header">
        <div className="contents_header_inner">
          {this.props.location.indexOf('settings/project') !== -1 && (
            <h3 className="content_title">
              {translate('settings.list.project_list')}
              <em>{this.props.projectCount}</em>
            </h3>
          )}
          {this.props.location.indexOf('settings/user') !== -1 && (
            <h3 className="content_title">
              {translate('settings.list.user_list')}
              <em>{this.props.userCount}</em>
            </h3>
          )}
          <div className="util_wrap">
            <div className="util_item ">
              <div className="search_files_wrap">
                <img src={searchIcon} alt="" className="icon" />
                <input
                  type="search_files"
                  className="seach_text"
                  placeholder={this.guideText()}
                  ref={(ref) => {
                    this.search = ref;
                  }}
                  onKeyPress={this.handleSearch}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                />
                <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                  x
                </a>
                {errSearch && (
                  <Label basic color="red" pointing>
                    {translate('contents_header.message.least_two_required_to_search')}
                  </Label>
                )}
                {isFocus && <Label pointing>{this.guideText()}</Label>}
              </div>
            </div>
            <div
              className="util_item common_filter_toggle_button"
              ref={(element) => {
                this.toggleBtn = element;
              }}
            >
              <a className="util_button icon_button" onClick={this.toggleMenu} onKeyUp={this.toggleMenu}>
                <img src={filterIcon} alt="" />
              </a>
              <div
                className={cx('common_filter', {
                  hide: !this.state.visible,
                })}
                style={{
                  height:
                    this.props.location.indexOf('project') !== -1
                      ? '200px'
                      : '320px',
                }}
              >
                <div className="common_filter_header">
                  <h2>{translate('contents_header.menu.filter_by')}</h2>
                </div>
                {this.props.location.indexOf('project') !== -1 ? (
                  <div
                    style={{
                      height: '100px',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <div className="common_filter_contents_inner">
                      <div className="common_filter_item">
                        <p className="title">{translate('settings.list.project_status')}</p>
                        <div className="checkbox_wrap">
                          <ul>
                            <li>
                              <Checkbox
                                label={translate('modal.title.active')}
                                value="active"
                                checked={checkValue.indexOf('active') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                            <li>
                              <Checkbox
                                label={translate('modal.title.inactive')}
                                value="inactive"
                                checked={checkValue.indexOf('inactive') > -1}
                                onChange={this.handleCheckChange}
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="common_filter_contents_inner">
                    <div className="common_filter_item">
                      <p className="title">{translate('settings.list.type')}</p>
                      <div className="checkbox_wrap">
                        <ul>
                          <li>
                            <Checkbox
                              label={translate('modal.title.local')}
                              value="source_local"
                              checked={checkValue.indexOf('source_local') > -1}
                              onChange={this.handleCheckChange}
                            />
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            <Checkbox
                              label={translate('modal.title.ldap')}
                              value="source_ldap"
                              checked={checkValue.indexOf('source_ldap') > -1}
                              onChange={this.handleCheckChange}
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="common_filter_item">
                      <p className="title">{translate('settings.list.permission')}</p>
                      <div className="checkbox_wrap">
                        <ul>
                          <li>
                            <Checkbox
                              label={translate('settings.list.user')}
                              value="permission_user"
                              checked={
                                checkValue.indexOf('permission_user') > -1
                              }
                              onChange={this.handleCheckChange}
                            />
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            <Checkbox
                              label={translate('settings.list.admin')}
                              value="permission_admin"
                              checked={
                                checkValue.indexOf('permission_admin') > -1
                              }
                              onChange={this.handleCheckChange}
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="common_filter_item">
                      <p className="title">{translate('settings.list.status')}</p>
                      <div className="checkbox_wrap">
                        <ul>
                          <li>
                            <Checkbox
                              label={translate('modal.title.active')}
                              value="status_active"
                              checked={checkValue.indexOf('status_active') > -1}
                              onChange={this.handleCheckChange}
                            />
                          </li>
                          <li style={{ marginBottom: '8px' }}>
                            <Checkbox
                              label={translate('modal.title.inactive')}
                              value="status_inactive"
                              checked={
                                checkValue.indexOf('status_inactive') > -1
                              }
                              onChange={this.handleCheckChange}
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                <div className="common_filter_footer">
                  <a className="cancel_button" onClick={this.closeMenu} onKeyUp={this.closeMenu}>
                    {translate('contents_header.button.cancel')}
                  </a>
                  <a className="apply_button" onClick={this.onSubmit} onKeyUp={this.onSubmit}>
                    {translate('contents_header.button.apply')}
                  </a>
                </div>
              </div>
            </div>
            <div className="button_wrap util_item">
              {this.props.location.indexOf('user') !== -1 && !this.props.state.user.isSuperAdmin ? (
                <a
                  className="gray_button util_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.assignProject}
                  onKeyUp={this.assignProject}
                >
                  {translate('settings.list.assign_project')}
                </a>
              ) : null}
              {this.props.state.user.isAdmin ? this.changeStatusBtn() : null}
              {this.props.state.user.isAdmin ? this.deleteBtn() : null}
              {this.props.location.indexOf('user') !== -1 && this.props.state.user.isAdmin ? (
                <a
                  className="add_button util_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.addNewProject}
                  onKeyUp={this.addNewProject}
                >
                  <span>+</span>
                  {translate('modal.button.add')}
                </a>
              ) : null}
              {this.props.location.indexOf('project') !== -1 ? (
                <a
                  className="add_button util_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.addNewProject}
                  onKeyUp={this.addNewProject}
                >
                  <span>+</span>
                  {translate('modal.button.add')}
                </a>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SettingContentsHeader;
